import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { checkDoShowAgentCommission } from '../../../store/slices/user';
import currencySymbol from '../../../helpers/currencySymbol';
import getCommissionLabel from '../../../helpers/getCommissionLabel';

const AgentCommission = ({
  agentCommission,
  className,
  commissionPercentage,
  currencyCode,
  mode,
}) => {
  const doShowAgentCommission = useSelector(checkDoShowAgentCommission);
  const { travelAgency } = useSelector((store) => store.user);

  if (!doShowAgentCommission) {
    return <></>;
  }
  return (
    <div
      className={`px-2 py-1 rounded bg-yellow-100 text-gray-800 text-xs whitespace-nowrap text-left min-w-fit inline-flex items-center gap-1 ${className}`}
    >
      <span className="font-medium">
        {getCommissionLabel(travelAgency, mode)}
        {commissionPercentage > 0 ? (
          <>
            {' '}
            (
            <NumberFormat value={commissionPercentage} displayType="text" decimalScale="0" />
            %)
          </>
        ) : null}
        :
      </span>
      <NumberFormat
        value={agentCommission === null ? 0 : agentCommission}
        prefix={currencySymbol(currencyCode)}
        displayType="text"
        thousandSeparator
        fixedDecimalScale="true"
        decimalScale="2"
      />
    </div>
  );
};

AgentCommission.propTypes = {
  agentCommission: PropTypes.number,
  className: PropTypes.string,
  commissionPercentage: PropTypes.number,
  currencyCode: PropTypes.string,
  mode: PropTypes.number,
};

AgentCommission.defaultProps = {
  className: '',
  agentCommission: null,
  commissionPercentage: null,
  currencyCode: 'USD',
  mode: null,
};

export default AgentCommission;
